// Users Icon Assets
import usersBase from './users-base.svg';
import usersOval from './users-oval.svg';
import usersPath1 from './users-path1.svg';
import usersPath2 from './users-path2.svg';
import usersPath3 from './users-path3.svg';

// Exchange Icon Assets
import exchangeIcon1 from './exchange-icon1.svg';
import exchangeIcon2 from './exchange-icon2.svg';
import exchangeIcon3 from './exchange-icon3.svg';
import exchangeIcon4 from './exchange-icon4.svg';

// Check Icon Assets
import checkIcon1 from './check-icon1.svg';

// Loader Icon Assets
import loaderIcon1 from './loader-icon1.svg';
import loaderIcon2 from './loader-icon2.svg';
import loaderIcon3 from './loader-icon3.svg';
import loaderIcon4 from './loader-icon4.svg';
import loaderIcon5 from './loader-icon5.svg';
import loaderIcon6 from './loader-icon6.svg';
import loaderIcon7 from './loader-icon7.svg';
import loaderIcon8 from './loader-icon8.svg';

// Other Assets
import avatarProfessional from './user-professional.svg';
import profileIcon from './profile-icon.svg';
import eyeIcon from './eye-icon.svg';
import ellipse from './ellipse.svg';
import autoBrightnessIcon from './auto-brightness-icon.svg';
import arrowRightIcon from './arrow-right-icon.svg';
import messageIcon from './message-icon.svg';
import testPipeIcon from './test-pipe.svg';

export const usersIconAssets = {
  base: usersBase,
  oval: usersOval,
  path1: usersPath1,
  path2: usersPath2,
  path3: usersPath3
};

export const exchangeIconAssets = {
  icon1: exchangeIcon1,
  icon2: exchangeIcon2,
  icon3: exchangeIcon3,
  icon4: exchangeIcon4,
  base: usersBase // Uses same base as users
};

export const checkIconAssets = {
  icon1: checkIcon1,
  base: usersBase // Uses same base as users
};

export const loaderIconAssets = {
  icon1: loaderIcon1,
  icon2: loaderIcon2,
  icon3: loaderIcon3,
  icon4: loaderIcon4,
  icon5: loaderIcon5,
  icon6: loaderIcon6,
  icon7: loaderIcon7,
  icon8: loaderIcon8,
  base: usersBase // Uses same base as users
};

export const todayAssignmentsAssets = {
  avatar: avatarProfessional,
  profileIcon: profileIcon,
  eyeIcon: eyeIcon,
  ellipse: ellipse,
  autoBrightnessIcon: autoBrightnessIcon,
  arrowRightIcon: arrowRightIcon,
  messageIcon: messageIcon
};

export const testIconAssets = {
  testPipe: testPipeIcon
};